import pkg from '../../package.json';

/**
 * The shared dev server.
 *
 * Selected by `ng build --configuration=dev`. Distinct from
 * `environment.ts`, which is for a backend running on this machine — this one
 * is the deployed dev environment that the dev pipeline publishes to.
 */
export const environment = {
  production: true,
  appVersion: pkg.version,
  /*
   * Google Analytics 4 property. Substituted by the deploy workflow from the
   * GA_MEASUREMENT_ID repository variable; analytics stays inert until this
   * holds a real `G-...` id.
   */
  gaMeasurementId: 'YOUR_GA_MEASUREMENT_ID_HERE',
  ssoBaseUrl: 'https://api.sso.dev.dormotech.app',
};
